import { space } from 'styled-system';
import { styled } from "../utils";
var Hr = styled.hr(space);
Hr.defaultProps = {
    my: [1, 3],
};
export default Hr;
//# sourceMappingURL=Hr.js.map